<template>
  <div class="article-box">
    <h5 class="article_title">联系我们</h5>
    <hr>

    <div class="article_content" v-html="data">
      <!--<p><img width="100%" src="../assets/img/9df13f6ed0211483d92e7df83db810c7.jpg" title="12.jpg" alt="12.jpg">
        <img width="100%" src="../assets/img/2bf00a299b73365bb04814a4be38bda0.jpg" title="联系我们 (2).jpg" alt="联系我们 (2).jpg">
        <img width="100%" src="../assets/img/eaa9ed89f19a16a6024f1e48894a6d36.jpg" title="联系我们 (5) (2).jpg" alt="联系我们 (5) (2).jpg">
        <img width="100%" src="../assets/img/e4985ad5d46bee8dd0ce3d23e0d4ed9b.jpg" title="43.jpg" alt="43.jpg">
        <img width="100%" src="../assets/img/e2e5cf21eac68fe90d2c01b994fcd22e.jpg" title="58.jpg" alt="58.jpg">
        <img width="100%" src="../assets/img/a2b3ff2f9978a9e69e2e81f43d9ad4ca.jpg" title="6.jpg" alt="6.jpg"></p>-->
    </div>
    <!---->


    <!--                    -->
  </div>
</template>

<script>
    export default {
        name: "helpcontact",
      data(){
        return{
          data:''
        }
      },
      methods:{
        getData(){
          let that = this;
          that
            .$http({
              url: "/",
              method: "post",
              data: {
                'nozzle': 'protocol',
                'type': 10,
              }
            })  .then(res => {
            let resData = res.data;
            if (res.data.code == 1) {
              that.data = resData.data;
            } else if (res.data.code == 0 || res.data.code == -1) {
              that.$message.error(res.data.msg);
            }
          });
        }
      },
      mounted() {
        this.getData();
      }
    }
</script>

<style scoped>
  .article_title{
    font-size: 20px;
    font-weight: 500;
  }
  .article_content>>>img{
    width: 100% !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/helpcontact.vue